import React from "react";
import { TextOverflow } from "utils/common";
import {
	Modal,
	Layout,
	Button
} from "rhombus-react";

import "./ViewVersionsModal.css";

export function renderRow(versionsArray = []){
	return versionsArray.map((val)=>{
		return(
			<tr key={`${val.name}`}>
				<td className="name-col">
					<TextOverflow value={val.name} />
				</td>
			</tr>
		);
	});
}

export function renderVersionsContent(message, versionsArray=[]){
	const columnHeadings = ["Version Name"];

	const $headingRow = columnHeadings.map((ea)=>{
		return(<th scope="col" key={ea}>{ea}</th>);
	});

	return(
		<div className="view-versions--container">
			<div className="info">{message}</div>
			<table className="view-versions basic-table">
				<thead className="header">
					<tr className="headrow">
						{$headingRow}
					</tr>
				</thead>
				<tbody>{renderRow(versionsArray)}</tbody>
			</table>
		</div>
	);
}

export default function ViewVersionsModal(props){
	let versionsArray = []
	 , { modalName, dependentValues, commonModalProps, navigationActions: { popModal } } = props
	 , { name, versionsInUse, versionsMissingFromCreatives } = dependentValues
	 , title = ""
	 , message = ""
	 ;

	if(modalName==="View Versions in Use"){
		versionsArray = versionsArray.concat(versionsInUse);
		message = "Versions in use that are required in order to assign decision tree:";
		title = `Versions in Use - ${name}`;
	}

	if(modalName==="View Missing Versions"){
		versionsArray = versionsArray.concat(versionsMissingFromCreatives);
		message = "Missing Versions that are required in order to assign decision tree:";
		title = `Missing Versions - ${name}`;
	}

	const Content = ()=>{
		return renderVersionsContent(message, versionsArray);
	};

	const Footer = () => {
		return (
			<Layout.ModalFooter>
				<Button className="close-button" theme="grey" onClick={popModal}>Back</Button>
			</Layout.ModalFooter>
		);
	};

	let modalProps = {
		...commonModalProps,
		title,
		className:`${commonModalProps.className} view-versions-modal`,
		renderContent: Content,
		renderFooter: Footer,
	};

	return (
		<Modal {...modalProps} />
	);
}

ViewVersionsModal.displayName = "MissingVersions";

export const PRIVATE = {
	ViewVersionsModal,
	renderRow,
	renderVersionsContent,
};
